import { props } from '@ngrx/store';
import { createNonUndoableAction } from '../utils/action-utils';

export const addShapeToSelectionType = '[Canvas Actions] Add Shape To Selection';
export const addShapeToSelection = createNonUndoableAction(addShapeToSelectionType, props<{ id: string }>());
export const removeShapeFromSelection = createNonUndoableAction('[Canvas Actions] Remove Shape From Selection', props<{ id: string }>());
export const clearSelection = createNonUndoableAction('[Canvas Actions] Clear Selection');
